export enum GetContactWith {
  Contribution = 'contribution',
  Profile = 'profile',
  Roles = 'roles',
  Tags = 'tags',
  IsReviewer = 'isReviewer',
  Origin = 'origin',
}
